import React, { Component } from 'react';
import ApiManager from '../../../apiManager';
import Loading from '../../Fragments/Loading';
import { trans } from '../../../helpers';
import config from '../../../baseConfig';
import Modal from '../../Fragments/Modal';
import FormMiddlewareError from '../../Fragments/FormMiddlewareError';

class B2bCreateCurator extends Component {

    constructor( props ){
        super( props );

        this.state = {
            accessByInn: true,
            addCuratorDisabledBtn: false,
            banList: '',
            banListArray: [],
            banListArrayLength: 0,
            email: '',
            formResponse: '',
            firstName: '',
            lastName: '',
            number: '',
            searchBanInputVal: '',
            searchBanInputFilterVal: '',
            searchInnInputVal: '',
            searchInnInputMaxLength: 8,
            searchInnDisabledBtn: false,
            searchInnScrollShowItemsDef: 20,
            searchInnScrollShowItems: 20,
            searchInnScrollLimit: 10,
            searchInnScrollCount: 0,
            successModal: false,
            editData: ''
        };

        // Component props
        this.componentIsMounted = true;
        this.banListArray = [];
        this.banListSelectedObject = {};

        // Bind own methods
        this.getInnDataSuccess = this.getInnDataSuccess.bind( this );
        this.editCuratorSuccess = this.editCuratorSuccess.bind( this );

    }

    componentDidMount() {

        if ( this.props.editCurator && this.props.pathname[1] === 'editCurator' && !isNaN( this.props.pathname[2] ) ) {

            // Get curator info
            ApiManager.getRequest({
                jwt: this.props.getDecryptedToken(),
                id: this.props.pathname[2]
            }, '/b2b' + this.props.curator + '/curator/edit').then( this.editCuratorSuccess, this.props.errorCallBack );

        }

        if ( !this.props.editCurator && this.props.curator === 'curator' ) {

            const { profileData } = this.props;

            if ( profileData !== '' && profileData.status === 'OK' ) {
                this.setState({
                    searchInnInputVal: profileData.data.inn
                }, () => this.doInnSearch( profileData.data.allow_inn !== '0' ));
            }

        }

    }

    editCuratorSuccess( resolve ){

        if ( !this.componentIsMounted ) {
            return;
        }

        // @test
        // resolve.data = { "status": "OK", "data": { "curator": { "id": 29, "first_name": "Karo", "last_name": "Habokyan", "contact_number": "7495494340", "email": "Karonn@Habokyan.com", "status": "new", "hash": null, "inn": "01808789", "allow_inn": "0", "creator_id": 7, "creator_type": "admin", "sort_order": 0, "show_status": "1", "creator": { "id": 7, "first_name": "Garik", "last_name": "Tadevosyan", "email": "garik@helix.am", "contact_number": "", "password_need_to_reset": "0", "status": "confirmed", "sort_order": 0 }, "bans": [ { "id": 21, "curator_id": 29, "ban": 112509461 }, { "id": 22, "curator_id": 29, "ban": 113302307 }, { "id": 23, "curator_id": 29, "ban": 112779156 }, { "id": 24, "curator_id": 29, "ban": 119238311 } ] } } };

        this.setState({
            editData: resolve.data
        });

        // Curator value setter
        this.curatorValueSetter();

    }

    curatorValueSetter(){

        if ( this.state.editData !== '' && this.state.editData.status === 'OK' ) {

            const currentCurator = this.state.editData.data.curator;
            const checkAll = Number( currentCurator.allow_inn ) === 1;

            this.setState({
               firstName: currentCurator.first_name,
               lastName: currentCurator.last_name,
               email: currentCurator.email,
               number: currentCurator.contact_number,
               searchInnInputVal: currentCurator.inn
            });

            this.doInnSearch( checkAll );

            if ( !checkAll && currentCurator.hasOwnProperty('bans') ) {
                currentCurator.bans.map(( item ) => this.banListSelectedObject[item.ban] = item.ban);
                this.setState({
                    banListArrayLength: currentCurator.bans.length,
                    banListArray: Object.keys( this.banListSelectedObject ).map( Number )
                });
            }

        }

    }

    componentWillUnmount(){

        this.componentIsMounted = false;

    }

    accessByInn(){

        if (
            ( this.state.banList === '' || this.state.banList.status !== 'OK' ) ||
            ( this.props.editCurator && this.props.curator === 'curator' && this.state.editData !== '' && this.state.editData.status === 'OK' && this.state.editData.data.curator.allow_inn === '0' ) ||
            ( !this.props.editCurator && this.props.curator === 'curator' && this.props.profileData !== '' && this.props.profileData.status === 'OK' && this.props.profileData.data.allow_inn === '0' )
        ) {
            return '';
        }

        return (
            <div className="form__form-box form__form-box--324 ver-top-box">
                <input
                    className="form__standard-checkbox dn"
                    id="access-by-inn"
                    type="checkbox"
                    checked={this.state.accessByInn}
                    onChange={() => this.setState({ accessByInn: !this.state.accessByInn })}
                />
                <label
                    className="form__standard-label sprite-a pr ver-top-box select-none"
                    htmlFor="access-by-inn"
                >{trans( this.props.b2bTrans, 'b2b.create_curator.access_by_inn_label' )}</label>
            </div>
        );

    }

    doInnSearch( accessByInn = true ){

        this.setState({
            accessByInn,
            banListArrayLength: 0,
            searchInnDisabledBtn: true,
            searchInnScrollCount: 0
        });
        this.banListSelectedObject = {};

        // Get INN
        ApiManager.getRequest({
            jwt: this.props.getDecryptedToken(),
            inn: this.state.searchInnInputVal
        }, '/b2b' + this.props.curator + '/getInfoByInn').then( this.getInnDataSuccess, this.props.errorCallBack );

    }

    getInnDataSuccess( resolve ){

        if ( !this.componentIsMounted ) {
            return;
        }

        // @test
        // resolve.data = { "status": "OK", "error": null, "data": { "inn": "00025841", "count": 155, "info": { "bans": [ { "business_name": "ԻՐԱՎԱԲԱՆԱԿԱՆ ՁԵՌՆԱՐԿՈՒԹՅՈՒՆ ԻՐԱՆԻ ԻՍԼԱՄԱԿԱՆ ՀԱՆՐԱՊԵՏՈ", "account_type": 45, "address": "Երեվան ԲՈՒԴԱՂՅԱՆ 1", "ban_status": "O", "ban": 112743857, "contact_number": 7410234900 }, { "business_name": "ԻՐԱՎԱԲԱՆԱԿԱՆ ՁԵՌՆԱՐԿՈՒԹՅՈՒՆ ԻՐԱՆԻ ԻՍԼԱՄԱԿԱՆ ՀԱՆՐԱՊԵՏՈ", "account_type": 45, "address": "Երեվան ԲՈՒԴԱՂՅԱՆ 1,ՄԱՇՏՈՑ", "ban_status": "O", "ban": 112761424, "contact_number": 7410653885 }, { "business_name": "ԻՐԱՎԱԲԱՆԱԿԱՆ ՁԵՌՆԱՐԿՈՒԹՅՈՒՆ ԻՐԱՆԻ ԻՍԼԱՄԱԿԱՆ ՀԱՆՐ.ԴԵՍՊ", "account_type": 45, "address": "Երեվան ԱՅԳԵՍՏԱՆ 9Փ 2Ա", "ban_status": "O", "ban": 112777376, "contact_number": 7410559977 }, { "business_name": "ԻՐԱՎԱԲԱՆԱԿԱՆ ՁԵՌՆԱՐԿՈՒԹՅՈՒՆ Իրանի Իսլամ. Հանր.դես.", "account_type": 43, "address": "Երևան Լվովյան 8", "ban_status": "O", "ban": 112812352, "contact_number": 7410633718 }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 35, "address": "Բուդաղյան 1", "ban_status": "O", "ban": 113297949, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 35, "address": "Բուդաղյան 1", "ban_status": "O", "ban": 113300489, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 35, "address": "Երևան Բուդաղյան 1", "ban_status": "O", "ban": 113301947, "contact_number": 7491777882 }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 35, "address": "Բուդաղյան 1", "ban_status": "O", "ban": 113301118, "contact_number": null }, { "business_name": "ԻՐԱՆԻ ԻՍԼԱՄԱԿԱՆ ՀԱՆՐԱՊԵՏՈ", "account_type": 43, "address": "Երեվան ԲՈՒԴԱՂՅԱՆ 1", "ban_status": "O", "ban": 116336093, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 5, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 118562574, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493362, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493368, "contact_number": null }, { "business_name": "Համատիրություն Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493380, "contact_number": 7491777882 }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493392, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493395, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493398, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493407, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493410, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493421, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493983, "contact_number": 7491777882 }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493987, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493989, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493991, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493645, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493647, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493650, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493652, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493655, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493662, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493669, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493676, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493683, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119493685, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119494155, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119494157, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119494161, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119494163, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119494170, "contact_number": null }, { "business_name": "ԻՐԱՆԻ ԻՍԼԱՄԱԿԱՆ ՀԱՆՐԱՊԵՏՈ", "account_type": 43, "address": "Երեվան ԲՈՒԴԱՂՅԱՆ 1", "ban_status": "O", "ban": 118895686, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 119383451, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1 Գրասենյա", "ban_status": "O", "ban": 119710047, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն ԻՐանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1 Գրասենյա", "ban_status": "O", "ban": 119669401, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090946, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090947, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090948, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090949, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090951, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090952, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090953, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090954, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090955, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090957, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090958, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090959, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ. Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090960, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090961, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090962, "contact_number": null }, { "business_name": "Սահմանափակ պատասխանատվությամբ ընկերություն Իրանի Իսլամ Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120090963, "contact_number": null }, { "business_name": "Իրանի Իսլամական հանրապետութ. դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120224752, "contact_number": null }, { "business_name": "ՀՀ իրավաբանական անձի մասնաճյուղ Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120466366, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120465899, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855925, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855927, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855929, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855931, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855933, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855915, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855917, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855919, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855921, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետության Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120855923, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120968247, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120968252, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120968034, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական անրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120968035, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120968036, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121008502, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121008504, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121008568, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121008569, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121008570, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997975, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997977, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997979, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997981, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997983, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997985, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997987, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 120997989, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034597, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121038339, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121038340, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121038341, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121038342, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121038343, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034598, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034599, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034600, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034601, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034602, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034603, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034604, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034605, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034606, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034607, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034608, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034609, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034610, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034611, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034612, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034613, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034658, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034659, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034660, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034661, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034662, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034663, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034664, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական  Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034665, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034666, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034667, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034668, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034669, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034670, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034671, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034672, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034673, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034705, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երևան Բուդաղյան 1", "ban_status": "O", "ban": 121034706, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034707, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034708, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034710, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034711, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034712, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034713, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034714, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121043046, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034894, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034895, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034896, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034897, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034898, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034899, "contact_number": null }, { "business_name": "Իրավաբանական անձանց միություն Իրանի Իսլամական Հանրապետություն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121034900, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081103, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081119, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081129, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121080868, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121080880, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081139, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081145, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081159, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081165, "contact_number": 7491777882 }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121080916, "contact_number": null }, { "business_name": "Իրանի Իսլամական Հանրապետութ. Դեսպանատուն", "account_type": 37, "address": "Երեվան Բուդաղյան 1", "ban_status": "O", "ban": 121081783, "contact_number": null } ] } } };

        const current = resolve.data;
        const newState = {
            banList: current,
            searchInnDisabledBtn: false,
            searchInnScrollShowItems: this.state.searchInnScrollShowItemsDef
        };

        if ( current !== '' && current.status === 'OK' && current.data.hasOwnProperty('info') && current.data.info.hasOwnProperty('bans') && current.data.count ) {
            newState['searchInnScrollCount'] = current.data.count;
            this.banListArray = current.data.info.bans.map(item => item.ban);
        }

        this.setState( newState );

    }

    innView( searchInnDisabledBtnNotValid ){

        if ( this.props.editCurator || ( !this.props.editCurator && this.props.curator === 'curator' ) ) {

            return (
                <div className="form__form-box form__form-box--324 ver-top-box pr">
                    <input
                        className="form__field form__field--pl10 fs14"
                        type="text"
                        placeholder={trans( this.props.b2bTrans, 'b2b.create_curator.search_inn_placeholder' )}
                        value={this.state.searchInnInputVal}
                        disabled={true}
                    />
                </div>
            );

        }

        return (
            <div className="form__form-box form__form-box--324 ver-top-box pr">
                <input
                    className="form__field fs14"
                    type="text"
                    placeholder={trans( this.props.b2bTrans, 'b2b.create_curator.search_inn_placeholder' )}
                    value={this.state.searchInnInputVal}
                    onChange={( event ) => {

                        let searchInnInputVal = event.target.value.trim().replace(/[^\d]/g, '');
                        const maxLength = this.state.searchInnInputMaxLength;

                        if ( searchInnInputVal.length > maxLength ) {
                            searchInnInputVal = searchInnInputVal.substr(0, maxLength );
                        }

                        this.setState( { searchInnInputVal } );
                    }}
                    onKeyDown={( event ) => {
                        if ( !searchInnDisabledBtnNotValid && event.keyCode === 13 ) {
                            this.doInnSearch();
                        }
                    }}
                />
                <button
                    className="form__search-btn sprite"
                    type="button"
                    disabled={this.state.searchInnDisabledBtn || searchInnDisabledBtnNotValid}
                    onClick={() => this.doInnSearch()}
                >&nbsp;</button>
            </div>
        );

    }

    topForm(){

        const searchInnDisabledBtnNotValid = this.state.searchInnInputVal.length !== this.state.searchInnInputMaxLength;

        let firstNameErrorClass = '',
            firstNameErrorBox = '',
            lastNameErrorClass = '',
            lastNameErrorBox = '',
            emailErrorClass = '',
            emailErrorBox = '',
            numberErrorClass = '',
            numberErrorBox = '',
            errorBox = '';

        if ( this.state.formResponse !== '' ) {

            if ( this.state.formResponse.status === 'INVALID_DATA' ) {

                if ( this.state.formResponse.errors.hasOwnProperty('first_name') ) {
                    firstNameErrorClass = ' form-error';
                    firstNameErrorBox = <div className="form-error-text fs11">{this.state.formResponse.errors.first_name}</div>;
                }

                if ( this.state.formResponse.errors.hasOwnProperty('last_name') ) {
                    lastNameErrorClass = ' form-error';
                    lastNameErrorBox = <div className="form-error-text fs11">{this.state.formResponse.errors.last_name}</div>;
                }

                if ( this.state.formResponse.errors.hasOwnProperty('email') ) {
                    emailErrorClass = ' form-error';
                    emailErrorBox = <div className="form-error-text fs11">{this.state.formResponse.errors.email}</div>;
                }

                if ( this.state.formResponse.errors.hasOwnProperty('contact_number') ) {
                    numberErrorClass = ' form-error';
                    numberErrorBox = <div className="form-error-text fs11">{this.state.formResponse.errors.contact_number}</div>;
                }

                if ( this.state.formResponse.errors.hasOwnProperty('inn') ) {
                    errorBox = <FormMiddlewareError message={this.state.formResponse.errors.inn} />;
                }

                if ( this.state.formResponse.errors.hasOwnProperty('ban') ) {
                    errorBox = <FormMiddlewareError message={this.state.formResponse.errors['ban']} />;
                }

            }

            if ( this.state.formResponse.status === 'ERROR' || this.state.formResponse.status === 'NOT_FOUND' ) {

                errorBox = <FormMiddlewareError message={this.state.formResponse.message} />;

            }

        }

        return (
            <form action="#" method="post" className="form form--search" onSubmit={( event ) => {
                event.preventDefault();
            }}>
                <div className="form__group">
                    <div
                        className={`form__form-box form__form-box--324 ver-top-box${firstNameErrorClass}`}
                    >
                        <label
                            className="form__label form__label--gray db fs14"
                            htmlFor="first-name"
                        >{trans( this.props.b2bTrans, 'b2b.create_curator.first_name_label' )}</label>
                        <input
                            className="form__field form__field--pl10 fs14"
                            type="text"
                            id="first-name"
                            placeholder={trans( this.props.b2bTrans, 'b2b.create_curator.first_name_placeholder' )}
                            value={this.state.firstName}
                            onChange={( event ) => this.setState({ firstName: event.target.value })}
                            autoFocus={this.props.editCurator}
                        />
                        {firstNameErrorBox}
                    </div>
                    <div
                        className={`form__form-box form__form-box--324 ver-top-box${lastNameErrorClass}`}
                    >
                        <label
                            className="form__label form__label--gray db fs14"
                            htmlFor="last-name-name"
                        >{trans( this.props.b2bTrans, 'b2b.create_curator.last_name_label' )}</label>
                        <input
                            className="form__field form__field--pl10 fs14"
                            type="text"
                            id="last-name-name"
                            placeholder={trans( this.props.b2bTrans, 'b2b.create_curator.last_name_placeholder' )}
                            value={this.state.lastName}
                            onChange={( event ) => this.setState({ lastName: event.target.value })}
                        />
                        {lastNameErrorBox}
                    </div>
                    <div
                        className={`form__form-box form__form-box--324 ver-top-box${numberErrorClass}`}
                    >
                        <label
                            className="form__label form__label--gray db fs14"
                            htmlFor="number"
                        >{trans( this.props.b2bTrans, 'b2b.create_curator.number_label' )}</label>
                        <input
                            className="form__field form__field--pl10 fs14"
                            type="text"
                            id="number"
                            placeholder={trans( this.props.b2bTrans, 'b2b.create_curator.number_placeholder' )}
                            value={this.state.number}
                            onChange={( event ) => this.setState({ number: event.target.value.trim().replace(/[^\d]/g, '') })}
                        />
                        {numberErrorBox}
                    </div>
                    <div
                        className={`form__form-box form__form-box--324 ver-top-box${emailErrorClass}`}
                    >
                        <label
                            className="form__label form__label--gray db fs14"
                            htmlFor="email"
                        >{trans( this.props.b2bTrans, 'b2b.create_curator.email_label' )}</label>
                        <input
                            className="form__field form__field--pl10 fs14"
                            type="text"
                            id="email"
                            placeholder={trans( this.props.b2bTrans, 'b2b.create_curator.email_placeholder' )}
                            value={this.state.email}
                            onChange={( event ) => this.setState({ email: event.target.value.trim() })}
                            disabled={this.props.editCurator}
                        />
                        {emailErrorBox}
                    </div>
                </div>
                {errorBox}
                <div className="form__group">
                    {this.innView( searchInnDisabledBtnNotValid )}
                    {this.accessByInn()}
                </div>
            </form>
        );

    }

    doSearch( banList ){

        return banList.reduce(( arr, item ) => {
            if ( item.ban.toString().search( this.state.searchBanInputFilterVal.toString() ) > -1 ) {
                arr.push(item);
            }
            return arr;
        }, []);

    }

    banList(){

        if ( this.state.searchInnDisabledBtn ) {
            return <Loading withBox={true} />;
        }

        let items = '';
        const current = this.state.banList;

        if ( current !== '' && current.status === 'OK' && current.data.hasOwnProperty('info') && current.data.info.hasOwnProperty('bans') && current.data.count ) {

            let banList = current.data.info.bans;

            if ( !this.state.accessByInn && this.state.searchBanInputFilterVal ) {
                banList = this.doSearch( banList );
            }

            items = banList.map(( item, index ) => {

                if (index + 1 > this.state.searchInnScrollShowItems) {
                    return '';
                }

                return (
                    <li className="main-wrapper__ban-item ver-top-box" key={index}>
                        <input
                            className="form__standard-checkbox dn"
                            id={`ban-${item.ban}`}
                            type="checkbox"
                            checked={this.state.accessByInn || this.banListSelectedObject.hasOwnProperty( item.ban )}
                            disabled={this.state.accessByInn}
                            onChange={() => {

                                if ( this.banListSelectedObject.hasOwnProperty( item.ban ) ) {
                                    delete this.banListSelectedObject[item.ban];
                                } else {
                                    this.banListSelectedObject[item.ban] = item.ban;
                                }

                                const collectedArray = Object.keys( this.banListSelectedObject ).map( Number );

                                this.setState({
                                    banListArray: collectedArray,
                                    banListArrayLength: collectedArray.length
                                });

                            }}
                        />
                        <label
                            className="form__standard-label sprite-a pr db select-none"
                            htmlFor={`ban-${item.ban}`}
                        >
                            <span className="form__standard-name db fb">{item.business_name}</span>
                            <span className="form__standard-number db fs14">{trans(this.props.b2bTrans, 'b2b.ban.number')} {item.ban}</span>
                        </label>
                    </li>
                );

            });

            if ( !items.length ) {
                items = <li className="main-wrapper__ban-empty tc">{trans( this.props.b2bTrans, 'b2b.create_curator.search_no_result' )}</li>;
            }

        }

        return (
            <ul className="main-wrapper__ban-list word-break">{items}</ul>
        );

    }

    searchBanList(){

        let searchGroup = '';

        if ( this.state.banList !== '' && this.state.banList.status === 'OK' ) {

            const isDisabled = this.state.accessByInn || this.state.searchInnScrollCount === 0;

            searchGroup = (
                <div className={`form__search-group${isDisabled ? ' form__search-group--disabled' : ''}`}>
                    <div className="form__form-box form__form-box--w-auto ver-top-box">
                        <label
                            className="form__label db"
                            htmlFor="search-ban"
                        >{trans( this.props.b2bTrans, 'b2b.create_curator.search_ban_list_label' )}</label>
                    </div>
                    <div className="form__form-box form__form-box--280 ver-top-box pr">
                        <input
                            className="form__field fs14"
                            type="text"
                            id="search-ban"
                            readOnly={isDisabled}
                            value={this.state.searchBanInputVal}
                            placeholder={trans( this.props.b2bTrans, 'b2b.create_curator.search_ban_list_placeholder' )}
                            onChange={( event ) => {

                                const newState = {
                                    searchBanInputVal: event.target.value.replace(/[^\d]/g, '')
                                };

                                if ( newState.searchBanInputVal === '' ) {
                                    newState['searchBanInputFilterVal'] = '';
                                    newState['searchInnScrollShowItems'] = this.state.searchInnScrollShowItemsDef;
                                }

                                this.setState( newState );

                            }}
                        />
                        <button
                            className="form__search-btn sprite"
                            type="submit"
                        >&nbsp;</button>
                    </div>
                </div>
            );
        }

        return searchGroup;

    }

    banInfoAction(){

        let selectAllCheckbox = '',
            countBans = '';

        if ( this.state.banList !== '' && this.state.banList.status === 'OK' ) {

            if ( !this.state.accessByInn ) {

                const isChecked = this.state.banListArrayLength === this.state.searchInnScrollCount;

                selectAllCheckbox = (
                    <div className="form__action-checkbox-block ver-top-box">
                        <input
                            className="form__standard-checkbox dn"
                            id="select-all"
                            type="checkbox"
                            checked={isChecked}
                            onChange={() => {

                                if ( isChecked ) {
                                    this.banListSelectedObject = {};
                                } else {
                                    this.banListArray.map(item => this.banListSelectedObject[item] = item);
                                }

                                const collectedArray = Object.keys( this.banListSelectedObject ).map( Number );

                                this.setState({
                                    banListArray: collectedArray,
                                    banListArrayLength: collectedArray.length
                                });

                            }}
                        />
                        <label
                            className="form__standard-label form__standard-label--big sprite-a pr db"
                            htmlFor="select-all"
                        >{trans(this.props.b2bTrans, 'b2b.create_curator.' + ( isChecked ? 'de_' : '' ) + 'select_label')}</label>
                    </div>
                );

            }

            countBans = (
                <div className="form__action-count-box ver-top-box">
                    <span className="form__action-count fb ver-top-box tc">{this.state.accessByInn ? this.state.searchInnScrollCount : this.state.banListArrayLength}</span>
                    <span className="form__action-count-title ver-top-box">{trans( this.props.b2bTrans, 'b2b.create_curator.ban_selected_title' )}</span>
                </div>
            );

        }

        return (
            <div className="form__action-box-left fl">
                {selectAllCheckbox}
                {countBans}
            </div>
        );

    }

    setBanList( data, banListArray ){

        for( let i = 0, l = banListArray.length; i < l; i++ ) {
            data['ban['+i+']'] = banListArray[i];
        }

        return data;

    }

    addCurator(){

        this.setState({ addCuratorDisabledBtn: true });

        const data = {
            jwt: this.props.getDecryptedToken(),
            _token: this.props.csrf_token.data,
            first_name: this.state.firstName,
            last_name: this.state.lastName,
            email: this.state.email,
            contact_number: this.state.number,
            inn: this.state.searchInnInputVal,
            allow_inn: this.state.accessByInn ? 1 : 0
        };

        if ( this.props.editCurator && this.props.pathname[1] === 'editCurator' && !isNaN( this.props.pathname[2] ) ) {
            data['id'] = this.props.pathname[2];
        }

        this.setBanList( data, ( this.state.accessByInn ? this.banListArray : this.state.banListArray ) );

        // Get INN
        ApiManager.postRequest(data, '/b2b' + this.props.curator + '/curator/edit').then( ( resolve ) => {

            if ( !this.componentIsMounted ) {
                return;
            }

            // @test
            // resolve.data = {"status": "OK"};
            // resolve.data = { "status": "INVALID_DATA", "errors": { "first_name": "beeline.curator.first_name.required", "last_name": "beeline.curator.last_name.required", "contact_number": "beeline.curator.contact_number.required", "email": "beeline.auth.login.email.required", "inn": "beeline.curator.inn.required", "ban.0": "beeline.curator.ban.invalid", "ban.1": "beeline.curator.ban.invalid", "ban.2": "beeline.curator.ban.invalid", "ban.3": "beeline.curator.ban.invalid" } };
            // resolve.data = { "status": "ERROR", "code": "beeline.b2b_curator.error.code", "message": "beeline.b2b.curation.email.exist", "data": null };

            const newState = {
                addCuratorDisabledBtn: false,
                formResponse: resolve.data
            };

            if ( resolve.data.status === 'OK' ) {

                newState['successModal'] = true;

            }

            this.setState( newState );

        }, this.props.errorCallBack );

    }

    bottomForm(){

        return (
            <form action="#" method="post" className="form form--search" onSubmit={( event ) => {
                event.preventDefault();
                this.setState({
                    searchBanInputFilterVal: this.state.searchBanInputVal
                });
            }}>
                {this.searchBanList()}
                {this.banList()}

                <div className="form__action-box clear-fix">
                    {this.banInfoAction()}
                    <div className="form__action-box-right fr tr">
                        <button
                            className={`btn btn--yellow ver-top-box${this.state.addCuratorDisabledBtn ? ' btn--loading' : ''}`}
                            type="button"
                            disabled={this.state.addCuratorDisabledBtn || ( this.state.accessByInn ? this.state.searchInnScrollCount === 0 : this.state.banListArrayLength === 0 )}
                            onClick={() => this.addCurator()}
                        >{trans( this.props.b2bTrans, 'b2b.' + ( this.props.editCurator ? 'edit' : 'create' ) + '_curator.btn_title' )}</button>
                        <button
                            className="btn btn--white ver-top-box"
                            type="button"
                            onClick={() => {
                                this.props.history.push( config.urlPrefix + this.props.urlPrefix + '/curatorList' );
                                this.props.updatePath();
                            }}
                        >{trans( this.props.b2bTrans, 'b2b.create_curator.cancel_btn_title' )}</button>
                    </div>
                </div>

            </form>
        );

    }

    infiniteScroll( event ){

        if ( !this.componentIsMounted ) {
            return;
        }

        if (
            (event.target.scrollTop + event.target.offsetHeight > event.target.scrollHeight - 100) &&
            ( this.state.searchInnScrollCount > this.state.searchInnScrollShowItems )
        ) {
            this.setState({
                searchInnScrollShowItems: this.state.searchInnScrollShowItems + this.state.searchInnScrollLimit
            });
        }

    }

    addCuratorSuccessModal(){

        if ( !this.state.successModal ) {
            return '';
        }

        return (
            <Modal
                title={trans(this.props.b2bTrans, 'b2b.' + ( this.props.editCurator ? 'edit' : 'create' ) + '_curator.success_modal.title')}
                description={trans(this.props.b2bTrans, 'b2b.' + ( this.props.editCurator ? 'edit' : 'create' ) + '_curator.success_modal.description')}
                agreeText={trans(this.props.b2bTrans, 'b2b.' + ( this.props.editCurator ? 'edit' : 'create' ) + '_curator.success_modal.agree')}
                agreeAction={() => {
                    this.props.history.push( config.urlPrefix + this.props.urlPrefix + '/curatorList' );
                    this.props.updatePath();
                }}
                className="modal--full"
            />
        );

    }

    render(){

        return(
            <div className="main-wrapper__right-inner main-wrapper__right-inner--list scroller-block pr" onScroll={( event ) => this.infiniteScroll( event )}>
                <h2 className="main-wrapper__right-inner-title main-wrapper__right-inner-title--pt-none fb fs20">{trans( this.props.b2bTrans, 'b2b.' + ( this.props.editCurator ? 'edit' : 'create' ) + '_curator.title' )}</h2>
                {this.topForm()}
                {this.bottomForm()}
                {this.addCuratorSuccessModal()}
            </div>
        );

    }

}

export default B2bCreateCurator;